import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export function GoldButton({ children, to, href, onClick, variant = "solid", className = "", type, ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium tracking-wide transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-background";
  const styles =
    variant === "solid"
      ? "bg-gradient-to-r from-gold-light via-gold to-gold-dark text-background hover:brightness-110 shadow-[0_8px_30px_-8px_rgba(212,175,55,0.6)]"
      : variant === "outline"
      ? "border border-gold/50 text-gold hover:bg-gold/10"
      : "text-foreground/80 hover:text-gold";

  const cls = `${base} ${styles} ${className}`;
  const inner = <motion.span whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }} className="inline-flex items-center gap-2">{children}</motion.span>;

  if (to) return <Link to={to} className={cls} {...props}>{inner}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{inner}</a>;
  return <button type={type || "button"} onClick={onClick} className={cls} {...props}>{inner}</button>;
}

export function SectionHeading({ overline, title, subtitle, center = false, className = "" }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
      {overline && <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4 font-medium">{overline}</p>}
      <h2 className="font-serif text-4xl sm:text-5xl leading-tight text-foreground">{title}</h2>
      {subtitle && <p className="mt-5 text-muted-foreground text-base sm:text-lg leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
